import { type GetTxfJobResponse as GetTxfJobResponseProto } from '@taxfyle/api-internal/internal/txf_pb'
import { type TxfJobProps } from '@/features/jobs/details/txf/TxfJob'
import { safeTimestampToDate } from '@/utils/grpc-util'

export function mapTxfJobProtoToProps(
  proto: GetTxfJobResponseProto,
): TxfJobProps {
  return {
    jobId: proto.getJobId(),
    createdAt: safeTimestampToDate(proto.getCreateTime()),
    modifiedAt: safeTimestampToDate(proto.getUpdateTime()),
  }
}
